export default {
    url: 'vanlife-roadtrips',
    include: ['us', 'ca', 'de', 'za', 'fr', 'uk', 'eu', 'it', 'es'],
};
